import { ChevronLeft, ChevronRight } from 'lucide-react';

import { Button } from './button';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from './select';

const defaultItemsPerPage = [10, 25, 50, 100];

type PaginationProps = {
  pagination: {
    currentPage: number;
    totalPages: number;
    onChange: (value: number) => void;
  };
  itemsPerPage?: {
    label: string;
    currentValue: number;
    onChange: (value: string) => void;
    options?: number[];
  };
};

export function Pagination({ pagination, itemsPerPage }: PaginationProps) {
  function handlePageChange(page: number): void {
    pagination.onChange(page);
  }

  function canPreviousPage(): boolean {
    return pagination.currentPage > 1;
  }

  function canNextPage(): boolean {
    return pagination.currentPage < pagination.totalPages;
  }

  return (
    <div className='flex w-full flex-row items-center justify-between gap-2'>
      <div className='flex items-center justify-start space-x-4'>
        <div className='font-medium text-muted-foreground text-sm'>
          Page {pagination.currentPage} of {pagination.totalPages}
        </div>

        {itemsPerPage && (
          <div className='flex items-center space-x-2 border-l pl-3'>
            <div className='whitespace-nowrap text-muted-foreground text-sm'>{itemsPerPage.label}</div>

            <Select defaultValue={String(itemsPerPage.currentValue)} onValueChange={itemsPerPage.onChange}>
              <SelectTrigger className='h-auto px-2 py-1.5'>
                <SelectValue placeholder={itemsPerPage.currentValue} />
              </SelectTrigger>

              <SelectContent>
                {(itemsPerPage.options ?? defaultItemsPerPage).map((item) => {
                  return (
                    <SelectItem key={item} value={String(item)}>
                      {item}
                    </SelectItem>
                  );
                })}
              </SelectContent>
            </Select>
          </div>
        )}
      </div>

      <div className='flex items-center space-x-6 lg:space-x-8'>
        <div className='flex items-center space-x-2'>
          <Button
            disabled={!canPreviousPage()}
            onClick={() => handlePageChange(pagination.currentPage - 1)}
            size='sm'
            variant='outline'
          >
            <ChevronLeft className='h-4 w-4' />
            <span>Previous</span>
          </Button>

          <Button
            disabled={!canNextPage()}
            onClick={() => handlePageChange(pagination.currentPage + 1)}
            size='sm'
            variant='outline'
          >
            <span>Next</span>
            <ChevronRight className='h-4 w-4' />
          </Button>
        </div>
      </div>
    </div>
  );
}
